<template>
  <div class="anchor-list-box">
    <div
      v-if="anchorList.length"
      class="anchor-group-box">
      <el-collapse
        v-model="expandCollapseItems"
        class="custom-collapse-box">
        <el-collapse-item
          :name="index"
          v-for="(group, index) in anchorList"
          :key="index">
          <template slot="title">
            <div class="group-title-box">
              <div class="group-info-box">
                <div class="expane-icon">
                  <i class="el-icon-caret-right" />
                </div>
                <div class="group-content-box">
                  <div
                    class="group-name-box text-overflow"
                    :title="group.groupName">
                    {{ group.groupName }}
                  </div>
                  <div class="edit-btn-box">
                    <el-button
                      type="text"
                      size="small"
                      :title="isGroupUnOverlap(group) ? '允许遮挡' : '禁止遮挡'"
                      :disabled="isDisabledBtn"
                      @click.stop="toggleGroupOverlap(group)">
                      <icon-svg
                        v-if="isGroupUnOverlap(group)"
                        icon-class="icon-yunxuzhedang" />
                      <icon-svg
                        v-else
                        icon-class="icon-jinzhizhedang" />
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div
            v-for="(anchor, i) in group.anchorPointList"
            class="anchor-list-item-box"
            :key="i">
            <div class="name-info-box">
              <div
                v-if="anchor.displayForm === 0"
                class="normal-type-box">
                【普通】
              </div>
              <div
                v-if="anchor.displayForm === 1"
                class="special-type-box">
                【闪烁】
              </div>
              <div
                class="name-box text-overflow"
                :title="anchor.name">
                {{ anchor.name }}
              </div>
            </div>
            <div
              class="img-box"
              @click="handleImgItemClick(anchor)">
              <img :src="getImgSrc(anchor.thumbnail)" />
            </div>
            <div class="bottom-box">
              <div class="time-box">
                {{ formatTime(anchor.creationTime) }}
              </div>
              <div class="btn-box">
                <el-button
                  type="text"
                  size="small"
                  title="锚点详情"
                  :disabled="isDisabledBtn"
                  @click.stop="openAnchorDetailsPanel(anchor)">
                  <icon-svg icon-class="icon-xinxi" />
                </el-button>
                <div class="comment-btn-box">
                  <el-button
                    :class="isAttachmentListVisible(anchor) ? 'active' : ''"
                    type="text"
                    size="small"
                    title="附件"
                    :disabled="isDisabledBtn"
                    @click.stop="expandAttachmentList(anchor)">
                    <icon-svg icon-class="icon-tianjiafujian" />
                  </el-button>
                  <div class="count-box">({{ anchor.attachmentCount }})</div>
                </div>
                <div class="comment-btn-box">
                  <el-button
                    :class="isCommentVisible(anchor) ? 'active' : ''"
                    type="text"
                    size="small"
                    title="评论"
                    :disabled="isDisabledBtn"
                    @click.stop="expandCommentList(anchor)">
                    <icon-svg icon-class="icon-pinglun" />
                  </el-button>
                  <div class="count-box">({{ anchor.commentCount }})</div>
                </div>
              </div>
            </div>
            <div
              class="attachment-list-box"
              v-if="isAttachmentListVisible(anchor)">
              <div
                v-for="(attachment, index) in attachmentList"
                :key="index"
                class="attachment-item-box">
                <div class="attachment-info-box">
                  <div class="icon-box">
                    <img :src="getFileTypeIcon(attachment.attachmentName)" />
                  </div>
                  <div class="info-box">
                    <div
                      class="text-overflow"
                      :title="attachment.attachmentName">
                      {{ attachment.attachmentName }}
                    </div>
                    <div class="size-box">
                      {{ `(${getFileSize(attachment.fileSize)})` }}
                    </div>
                  </div>
                </div>
                <div class="attachment-btn-box">
                  <el-button
                    v-if="isViewAttachmentBtnVisible(attachment)"
                    type="text"
                    size="small"
                    title="查看"
                    @click.stop="viewAttachment(attachment)">
                    <icon-svg icon-class="icon-chakanxiangqing" />
                  </el-button>
                  <el-button
                    type="text"
                    size="small"
                    title="下载"
                    @click.stop="downloadAttachment(attachment)">
                    <icon-svg icon-class="icon-xiazai" />
                  </el-button>
                </div>
              </div>
            </div>
            <div
              class="comment-box"
              v-if="isCommentVisible(anchor)">
              <div
                class="comment-list-box"
                v-if="commentList.length">
                <div
                  class="comment-item-box"
                  v-for="(comment, index) in commentList"
                  :key="index">
                  <div class="comment-header-box">
                    <div class="user-info-box">
                      <!-- <div class="user-icon-box"></div> -->
                      <div class="user-name-box">{{ comment.creatorName }}</div>
                      <div class="time-info-box">
                        {{ formatTime(comment.creationTime) }}
                      </div>
                    </div>
                  </div>
                  <div class="comment-content-box">
                    {{ comment.comment }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div
      class="empty-box"
      v-else>
      <div class="tip-box">
        <div class="img-box">
          <img :src="require('@/assets/img/no-params.png')" />
        </div>
        <div class="text-box">
          <span>暂无锚点</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTime, formatFileSize } from '@/utils/generalMethods'

import {
  getAnchorDetailsService,
  getAnchorAttachmentListService,
  getAnchorCommentListService
} from '@/service/share/sceneShareInterface.js'

export default {
  data() {
    return {
      expandCollapseItems: [],
      currSelectGroup: {},
      unOverlapGroups: [],

      // 当前激活的锚点，用于控制展示附件和评论
      currActiveAnchorId: '',
      currActiveType: '',
      attachmentList: [],

      currComment: {
        anchorId: '',
        anchorName: '',
        content: ''
      },
      commentList: [],
      isAllCommentLoaded: false,
      currPage: 1,
      pageSize: 10
    }
  },
  props: {
    isDisabledBtn: Boolean,
    anchorList: Array,
    refreshAnchorList: Function
  },
  watch: {
    anchorList(newVal, oldVal) {
      if (newVal.length !== oldVal.length) {
        this.expandCollapseItems = []
        newVal.forEach((item, index) => {
          if (item.anchorPointList.length) {
            this.expandCollapseItems.push(index)
          }
        })
      }
    }
  },
  methods: {
    handleImgItemClick(anchorInfo) {
      // let anchorId = anchorInfo.sceneAnchorPointId;
      // window.BlackHole3D.Anchor.setCamToAnc(anchorId, 20);

      let visualAngle = JSON.parse(anchorInfo.visualAngle)

      let camLoc = new window.BlackHole3D.REForceCamLoc()
      camLoc.camPos = visualAngle.camPos
      camLoc.camRotate = visualAngle.camRotate
      window.BlackHole3D.Camera.setCamLocateTo(camLoc, 0.5, 1)
    },
    toggleGroupOverlap(groupInfo) {
      const BlackHole3D = window.BlackHole3D
      let findIndex = this.unOverlapGroups.findIndex(
        item => item.groupId === groupInfo.groupId
      )
      if (findIndex !== -1) {
        BlackHole3D.Anchor.setAncCanOverlap(groupInfo.groupId, true)
        this.unOverlapGroups.splice(findIndex, 1)
      } else {
        BlackHole3D.Anchor.setAncCanOverlap(groupInfo.groupId, false)
        this.unOverlapGroups.push(groupInfo)
      }
    },
    isGroupUnOverlap(groupInfo) {
      let find = this.unOverlapGroups.find(
        item => item.groupId === groupInfo.groupId
      )
      return find ? true : false
    },
    openAnchorDetailsPanel(anchorInfo) {
      this.queryAnchorDetails(anchorInfo).then(anchorDetails => {
        anchorDetails.groupName = anchorInfo.groupName
        this.$emit('openAnchorDetailsPanel', anchorDetails)
      })
    },
    expandAttachmentList(anchorInfo) {
      if (this.currComment.content) {
        let anchorName = this.currComment.anchorName
        this.$message(`${anchorName}正在进行评论，请发布后再查看附件`)
        return
      }

      if (this.isAttachmentExpanded(anchorInfo)) {
        this.currActiveAnchorId = ''
        this.currComment = {
          anchorId: '',
          anchorName: '',
          content: ''
        }
        return
      }

      this.attachmentList = []
      this.currActiveType = 'attachment'
      this.currComment = {
        anchorId: anchorInfo.sceneAnchorPointId,
        anchorName: anchorInfo.name,
        content: ''
      }

      let anchorId = anchorInfo.sceneAnchorPointId
      this.currActiveAnchorId = anchorId
      this.queryAttachmentList(anchorId).then(attachmentList => {
        if (attachmentList.length) {
          this.attachmentList = attachmentList
        } else {
          this.currActiveAnchorId = ''
          this.$message.warning('当前锚点没有附件')
        }
      })
    },
    isAttachmentExpanded(anchorInfo) {
      let anchorId = anchorInfo.sceneAnchorPointId
      if (this.currActiveType !== 'attachment') return false

      if (anchorId === this.currActiveAnchorId) {
        return true
      } else {
        return false
      }
    },
    viewAttachment(attachmentInfo) {
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = this.$route.query.token
      let attachmentUrl = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`

      const fileTypeMap = [
        {
          typeValue: 'text',
          subTypes: ['txt']
        },
        {
          typeValue: 'document',
          subTypes: ['docx']
        },
        {
          typeValue: 'excel',
          subTypes: ['xls', 'xlsx']
        },
        {
          typeValue: 'pdf',
          subTypes: ['pdf']
        }
      ]
      let fileName = attachmentInfo.attachmentName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()
      let find = fileTypeMap.find(item => item.subTypes.includes(fileType))
      let attachmentType = find.typeValue

      const routerUrl = this.$router.resolve({
        path: `../../../attachmentView`,
        query: { attachmentType, attachmentUrl }
      })

      window.open(routerUrl.href, '_blank')
    },
    downloadAttachment(attachmentInfo) {
      let url = ''
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = this.$route.query.token
      if (window.downloadUrl.includes('http')) {
        url = `${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      } else {
        url = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      }

      this.downloadURL(url, 1)
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    expandCommentList(anchorInfo) {
      if (this.currComment.content) {
        let anchorName = this.currComment.anchorName
        this.$message(`${anchorName}正在进行评论，请发布后再查看评论`)
        return
      }

      if (this.isCommentExpanded(anchorInfo)) {
        this.currActiveAnchorId = ''
        this.currComment = {
          anchorId: '',
          anchorName: '',
          content: ''
        }
        return
      }

      this.commentList = []
      this.currActiveType = 'comment'

      let anchorId = anchorInfo.sceneAnchorPointId
      this.currActiveAnchorId = anchorId
      this.currPage = 1
      this.queryCommentList().then(commentList => {
        this.commentList = commentList
      })
    },
    isCommentExpanded(anchorInfo) {
      let anchorId = anchorInfo.sceneAnchorPointId
      if (this.currActiveType !== 'comment') return false

      if (anchorId === this.currActiveAnchorId) {
        return true
      } else {
        return false
      }
    },
    handleScroll() {
      // 防止每次重新渲染都会触发滚动事件
      if (this.commentList.length < this.pageSize) return

      if (this.isAllCommentLoaded) return
      this.currPage++
      this.queryCommentList().then(commentList => {
        if (commentList.length) {
          this.commentList = [...this.commentList, ...commentList]
        } else {
          this.isAllCommentLoaded = true
        }
      })
    },
    isAttachmentListVisible(anchorInfo) {
      let anchorId = anchorInfo.sceneAnchorPointId
      let isActiveAnchor = this.currActiveAnchorId === anchorId
      let isActiveType = this.currActiveType === 'attachment'
      let isExistAttachment = this.attachmentList.length > 0
      if (isActiveAnchor && isActiveType && isExistAttachment) {
        return true
      } else {
        return false
      }
    },
    isViewAttachmentBtnVisible(attachmentInfo) {
      let fileName = attachmentInfo.attachmentName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      const visibleFileTypes = ['docx', 'xls', 'xlsx', 'pdf', 'txt']
      return visibleFileTypes.includes(fileType)
    },
    isCommentVisible(anchorInfo) {
      let anchorId = anchorInfo.sceneAnchorPointId
      let isActiveAnchor = this.currActiveAnchorId === anchorId
      let isActiveType = this.currActiveType === 'comment'
      if (isActiveAnchor && isActiveType) {
        return true
      } else {
        return false
      }
    },
    queryAnchorDetails(anchorInfo) {
      return new Promise(resolve => {
        let anchorId = anchorInfo.sceneAnchorPointId
        let headers = this.getHeaders()
        getAnchorDetailsService(anchorId, headers).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryAttachmentList(anchorId) {
      return new Promise(resolve => {
        let headers = this.getHeaders()
        getAnchorAttachmentListService(anchorId, headers).then(response => {
          if (response.isSuccess) {
            let attachmentList = response.data
            resolve(attachmentList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryCommentList() {
      return new Promise(resolve => {
        let params = {
          sceneAnchorPointId: this.currActiveAnchorId,
          resultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }
        let headers = this.getHeaders()
        getAnchorCommentListService(params, headers).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let commentList = data.items
            resolve(commentList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    refreshCommentList() {
      return new Promise(resolve => {
        this.currPage = 1
        this.queryCommentList().then(commentList => {
          this.commentList = commentList
          resolve()
        })
      })
    },
    getFileTypeIcon(fileName) {
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      let imgSrc = ''
      switch (fileType) {
        case 'doc':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'docx':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'xls':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'xlsx':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'pdf':
          imgSrc = require('@/assets/icon/pdf.png')
          break
        case 'txt':
          imgSrc = require('@/assets/icon/txt.png')
          break
        case 'zip':
          imgSrc = require('@/assets/icon/zip.png')
          break
        default:
          imgSrc = require('@/assets/icon/png.png')
          break
      }

      return imgSrc
    },
    getFileSize(fileSize) {
      let size = formatFileSize(fileSize).fileSize
      let unit = formatFileSize(fileSize).unit
      let fileSizeStr = `${size}${unit}`
      return fileSizeStr
    },
    getImgSrc(thumbnailSrc) {
      let timestamp = new Date().getTime()
      let imgSrc = `${window.imageBaseUrl}/${thumbnailSrc}?timestamp=${timestamp}`
      return imgSrc
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.anchor-list-box {
  flex-grow: 1;
  overflow: hidden;

  .anchor-group-box {
    margin-top: 8px;
    max-height: 100%;
    overflow-y: auto;

    .custom-collapse-box {
      border: none;

      :deep(.el-collapse-item) {
        margin: 8px 0px;

        &:first-child {
          margin-top: 0px;
        }

        .el-collapse-item__header {
          height: 26px;
          line-height: 26px;
          border: none;
          background: transparent;

          &.is-active {
            .group-info-box {
              background: var(--anchor-group-bgColor);

              .expane-icon {
                transform: rotate(90deg);
              }
            }
          }

          .group-title-box {
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            overflow: hidden;

            .group-info-box {
              flex-grow: 1;
              display: flex;
              align-items: center;
              margin-right: 4px;
              padding: 0px 8px;
              border-radius: 3px;
              overflow: hidden;
              color: var(--anchor-list-label-text-color);

              &:hover {
                background: var(--anchor-group-bgColor);

                .group-content-box {
                  .edit-btn-box {
                    display: flex;
                    align-items: center;
                  }
                }
              }

              .rename-group-box {
                flex-grow: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-left: 4px;

                .input-box {
                  width: 60%;

                  .el-input__inner {
                    height: 26px;
                    line-height: 26px;
                  }
                }

                .action-button-box {
                  display: flex;
                  align-items: center;

                  .submit-btn {
                    color: #00e005;
                  }

                  .cancel-btn {
                    color: #ff2626;
                    margin-left: 4px;
                  }
                }
              }

              .group-content-box {
                flex-grow: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-left: 4px;
                overflow: hidden;

                .group-name-box {
                  color: var(--anchor-list-label-text-color);
                }

                .edit-btn-box {
                  display: none;
                  align-items: center;

                  .el-button {
                    padding: 4px 0px;
                    color: var(--anchor-list-icon-color);

                    & + .el-button {
                      margin-left: 4px;
                    }

                    &:hover {
                      color: var(--base-primary-bgColor);
                      background: var(--base-bg-light-color77);
                    }
                  }
                }
              }
            }

            .merge-btn-box {
              .normal-btn {
                padding: 6px 16px;
              }
            }
          }

          .el-collapse-item__arrow {
            display: none;
          }
        }

        .el-collapse-item__wrap {
          background: transparent;
          border: none;
          overflow: hidden;

          .el-collapse-item__content {
            padding-bottom: 0px;
          }

          .anchor-list-item-box {
            margin: 8px 0px;
            padding: 8px;
            border-radius: 8px;
            text-align: left;
            border: 1px solid var(--anchor-list-border-color);
            background: var(--anchor-list-bgColor);

            .name-info-box {
              display: flex;
              align-items: center;
              font-weight: 400;
              line-height: 22px;
              color: var(--anchor-list-text-color);
              text-align: left;

              .normal-type-box {
                flex-shrink: 0;
                color: var(--anchor-list-text-title-color);
              }
              .special-type-box {
                flex-shrink: 0;
                color: rgba(227, 115, 24, 1);
              }
            }

            .img-box {
              height: 176px;
              border-radius: 6px;
              cursor: pointer;

              img {
                width: 100%;
                height: 100%;
                border-radius: 6px;
                object-fit: cover;
              }
            }

            .bottom-box {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 4px;

              .time-box {
                font-weight: 400;
                font-size: 14px;
                color: var(--anchor-list-text-title-color);
              }

              .btn-box {
                display: flex;
                align-items: center;

                .comment-btn-box {
                  display: flex;

                  .count-box {
                    color: var(--base-primary-bgColor);
                  }
                }

                .el-button--text {
                  margin-left: 0px;
                  color: var(--anchor-list-text-icon-color);
                  padding: 2px;

                  &:hover {
                    color: var(--base-primary-bgColor);
                    background: var(--base-bg-light-color77);
                  }

                  &.active {
                    color: var(--base-primary-bgColor);
                    background: var(--base-bg-light-color77);
                  }
                }
              }
            }

            .attachment-list-box {
              font-size: 14px;
              .attachment-item-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 4px 0px;
                padding: 5px 8px;
                border-radius: 8px;
                background: var(--attachment-bg-color);
                border: 1px solid var(--attachment-border-color);

                .attachment-info-box {
                  display: flex;
                  align-items: center;
                  overflow: hidden;

                  .icon-box {
                    img {
                      vertical-align: bottom;
                    }
                  }

                  .info-box {
                    display: flex;
                    align-items: center;
                    margin-left: 5px;
                    margin-right: 15px;
                    color: var(--attachment-normal-color);
                    overflow: hidden;

                    .size-box {
                      margin-left: 5px;
                    }
                  }
                }

                .attachment-btn-box {
                  display: flex;
                  align-items: center;
                  flex-shrink: 0;

                  .el-button--text {
                    margin-left: 0px;
                    color: var(--attachment-normal-color);
                    padding: 2px;

                    &:hover {
                      background: var(--base-bg-dark-color33);
                    }
                  }
                }
              }
            }

            .comment-box {
              .comment-input-box {
                display: flex;
                align-items: center;

                .publish-icon-box {
                  margin-left: 5px;
                  color: var(--base-primary-bgColor);
                  background: var(--base-bg-light-color77);
                  cursor: pointer;
                }
              }

              .comment-list-box {
                margin-top: 8px;
                max-height: 300px;
                overflow-y: auto;

                .comment-item-box {
                  margin: 4px 0px;
                  padding: 6px;
                  border-radius: 6px;
                  background: var(--comment-bg-color);

                  .comment-header-box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .user-info-box {
                      display: flex;
                      align-items: center;

                      .user-name-box {
                        font-size: 14px;
                        color: var(--comment-user-color);
                      }

                      .time-info-box {
                        margin-left: 8px;
                        color: var(--comment-time-color);
                        font-size: 12px;
                      }
                    }

                    .close-icon-box {
                      display: flex;
                      color: var(--comment-icon-color);
                      cursor: pointer;
                      padding: 5px;
                      border-radius: 4px;

                      &:hover {
                        background: var(--comment-icon-hover-color);
                      }
                    }
                  }

                  .comment-content-box {
                    margin-top: 6px;
                    text-align: left;
                    font-size: 12px;
                    color: var(--comment-user-color);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .empty-box {
    display: flex;
    height: 100%;

    .tip-box {
      margin: auto;
      font-size: 12px;
      color: var(--page-tips-text-color);

      .text-box {
        width: 200px;
        margin: auto;
        line-height: 22px;
      }

      .bold-text-box {
        font-weight: bold;
        color: var(--page-tips-text-bold-color);
      }
    }
  }
}
</style>
